const updateCron = async ({ params, api }) => {
  const { previousData } = params;
  const { id } = previousData;
  return await api(`cron/${id}`, { body: params.data, method: 'PUT' })
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default updateCron;